import { useMemo } from 'react';
import { css, type Theme } from '@emotion/react';
import { darken, transparentize } from 'polished';
import { Copy, HardDrives, Plus, TerminalWindow, Toolbox } from '@phosphor-icons/react';
import { createVSCodeUri } from 'common/commonUtil';
import { CoreInstanceTypeTexts } from 'common/core/CoreInstanceConstants';
import type { StackConfig } from 'common/stack/StackConfigDocuments';
import { useDeploymentClientState } from 'client/state/DeploymentClientState';
import { Button } from 'client/components/Button';
import { RamGraph } from 'client/components/Graph/RamGraph';
import { StatisticGraph } from 'client/components/Graph/StatisticGraph';
import { createStackBackgroundUri } from 'client/components/Icons/StackBackground';
import { StackFull } from 'client/components/Icons/StackFull';
import { Input } from 'client/components/Input';
import { Stack } from 'client/components/Stack';
import { Typography } from 'client/components/Typography';

export const ClusterCard = () => {
  const deploymentID = useDeploymentClientState((state) => state.document?.id);
  const coreInstanceTypeID = useDeploymentClientState((state) => state.document?.coreInstanceTypeID);

  return (
    <Stack css={cardStyle}>
      <div css={headerStyle}>
        <Typography variant="h6">
          <HardDrives size={24} /> Cluster
        </Typography>
        {coreInstanceTypeID && (
          <section css={sizeStyle}>
            <Typography variant="h5">{CoreInstanceTypeTexts[coreInstanceTypeID]}</Typography>
          </section>
        )}
      </div>
      <Stack>
        <RamGraph deploymentID={deploymentID} />
        <StatisticGraph deploymentID={deploymentID} />
      </Stack>
    </Stack>
  );
};

const cardStyle = (theme: Theme) => css`
  position: relative;
  padding: 26px;
  border-radius: ${theme.borderRadius}px;
  border: 2px solid ${theme.color.grey[60]};
  box-sizing: border-box;
`;

const headerStyle = css`
  display: flex;
  z-index: 1;

  > h6 {
    display: flex;
    align-items: center;
    gap: 8px;
    flex: 1;

    > svg {
      translate: 0 -2px;
    }
  }
`;

const sizeStyle = (theme: Theme) => css`
  width: 56px;
  text-align: center;
  border: 2px solid ${transparentize(0.95, theme.color.foreground)};
  border-radius: ${theme.borderRadius}px;

  > h5 {
    transform: translateY(2px);
  }
`;
